<script setup lang="ts">
  import { inject, useCssModule } from 'vue';

  import Icon from '../Icon/Icon.vue';
  import { THUMBNAIL_INJECTION } from '../ThumbnailGroup/ThumbnailGroup.keys';

  const classes = useCssModule();

  const { radius } = inject(THUMBNAIL_INJECTION.key, THUMBNAIL_INJECTION.defaults);
</script>

<template>
  <li
    class="stash-thumbnail-empty"
    :class="[
      classes['thumbnail-empty'],
      {
        'rounded-full': radius === 'circle',
        rounded: radius === 'rounded',
      },
    ]"
    data-test="stash-thumbnail-empty"
  >
    <Icon name="image" data-test="stash-thumbnail-empty|icon" />
  </li>
</template>

<style module>
  @reference "../../../styles/main.css";

  .thumbnail-empty {
    height: --spacing(12);
    width: --spacing(12);
    border-width: 1px;
    outline-width: --spacing(1);
    border-style: dashed;
    border-color: var(--colors-ice-500);
    background-color: var(--colors-ice-100);
    color: var(--colors-ice-700);
    display: flex;
    justify-content: center;
    align-items: center;
  }
</style>
